import {
  httpClient,
  excelHttpClient,
} from "../network/httpclient/HttpClientFactory";

const testBookList = (param) =>
  httpClient.get(`/testBooks`, { params: param }).then((res) => res.data);

const testBookStrengthList = (param) =>
  httpClient
    .get(`/testBooks/strength`, { params: param })
    .then((res) => res.data);

const testBookStrengthErrorList = (param) =>
  httpClient
    .get(`/testBooks/strength/error`, { params: param })
    .then((res) => res.data);

const testBookCount = (siteId) =>
  httpClient.get(`/testBooks/count/${siteId}`).then((res) => res.data);

const testBookCountForESG = (siteId) =>
  httpClient.get(`/testBooks/count/esg/${siteId}`).then((res) => res.data);

const testBookCountByTester = (siteId) =>
  httpClient.get(`/testBooks/count/tester/${siteId}`).then((res) => res.data);

const CountBySupervisor = (siteId) =>
  httpClient
    .get(`/testBooks/count/supervisor/${siteId}`)
    .then((res) => res.data);

const excelDown = (url, param) =>
  excelHttpClient.get(url, { params: param }).then((res) => {
    var disposition = res.headers["content-disposition"];
    var fileName = decodeURI(
      disposition.substring(
        disposition.indexOf("filename=") + 9,
        disposition.length
      )
    );

    const blob = new Blob([res.data], { type: res.headers["content-type"] });

    var fileUrl = window.URL.createObjectURL(blob);
    var fileLink = document.createElement("a");

    fileLink.href = fileUrl;
    fileLink.download = fileName;
    document.body.appendChild(fileLink);

    fileLink.click();
    fileLink.remove();
  });

export default {
  testBookList,
  testBookCount,
  testBookCountByTester,
  excelDown,
  CountBySupervisor,
  testBookStrengthList,
  testBookStrengthErrorList,
  testBookCountForESG,
};
